import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import AppRouter from "./routes/AppRouter";
import React from "react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import "./css/default.css";
import "./css/index.css";
import AppLayout from "./layout/AppLayout";
import ScrollToTop from "./utils/ScrollToTop";

const App = () => {

  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AppLayout>
          <ScrollToTop/>
          <AppRouter />
        </AppLayout>
      </QueryClientProvider>
    </>
  );
};

export default App;



